import { Component } from '@angular/core';
import { CommunityService } from '@common/services/community.service';
import { LanguageService } from '@common/services/language.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent {
    year = new Date().getFullYear();

    get communityCode() { return this.communityService.communityCode; }
    get languageCode() { return this.languageService.currentLanguageCode; }

    constructor(
        private communityService: CommunityService,
        private languageService: LanguageService) { }
}
